import React from 'react'

const LiveStreamSettings = () => {
  return (
    <div>LiveStreamSettings</div>
  )
}

export default LiveStreamSettings